import { LANGUAGE_CONFIG } from '@config/language.config';

export const ACTIONS_CONFIG = {
  add: {
    id: 'add',
    name: LANGUAGE_CONFIG.button.add,
    code: 'AGREGAR',
    icon: 'plus'
  },
  cancel: {
    id: 'cancel',
    name: LANGUAGE_CONFIG.button.disable,
    code: 'ANULAR',
    icon: 'ban'
  },
  reverseadm: {
    id: 'reverseadm',
    name: LANGUAGE_CONFIG.button.reverse,
    code: 'REVERSAR',
    icon: 'undo'
  },
  delete: {
    id: 'delete',
    name: LANGUAGE_CONFIG.button.delete,
    code: 'ELIMINAR',
    icon: 'trash'
  },
  detail: {
    id: 'detail',
    name: LANGUAGE_CONFIG.button.detail,
    code: 'DETALLE',
    icon: 'search'
  },
  download: {
    id: 'download',
    name: LANGUAGE_CONFIG.button.download,
    code: 'DESCARGAR',
    icon: 'download'
  },
  edit: {
    id: 'edit',
    name: LANGUAGE_CONFIG.button.edit,
    code: 'EDITAR',
    icon: 'pen'
  },
  editId: {
    id: 'editId',
    name: LANGUAGE_CONFIG.button.editId,
    code: 'EDITAR DOCUMENTO',
    icon: 'user-edit'
  },
  list: {
    id: 'list',
    name: LANGUAGE_CONFIG.button.list,
    code: 'LISTAR',
    icon: 'list-ul'
  },
  search: {
    id: 'search',
    name: LANGUAGE_CONFIG.button.search,
    code: 'CONSULTAR',
    icon: 'search'
  }
};

export class Actions {
  add = false;
  cancel = false;
  delete = false;
  detail = false;
  download = false;
  edit = false;
  editId = false;
  search = false;
  reverseadm = false;
}
